/**
 * Questa è la classe per il Repository dei validatori
 * Quindi tutti i metodi di validazione che necessitano di una conferma da parte di un servizio
 *
 */
import axios, { AxiosResponse } from "axios";
import axiosRetry from "axios-retry";
import { getResponseMessage } from "core/interfaces/data/Base";
import { IValidatorsRequest, IValidatorsResponse } from "core/interfaces/data/IValidatorsRequest";

// questo serve per fare la richiesta una seconda volta se in caso la prima non va a buon fine
axiosRetry(axios, {
	retries: 2,
});

// serve per settare i cookie in risposta
axios.defaults.withCredentials = true;

class ValidatorsRepository {
	async checkMail(props: IValidatorsRequest): Promise<IValidatorsResponse | undefined> {
		const url = `${window.CONFIG.REACT_APP_WS_HSB}/CheckMailExists`;

		try {
			const res = await axios.post<IValidatorsRequest, AxiosResponse<IValidatorsResponse>>(url, props);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			return res.data;
		} catch (err) {
			console.log(err);
		}
	}
}
var ValidatorsRep= new ValidatorsRepository()
export default ValidatorsRep;
